import React, { useState, useEffect } from 'react';
import { Grid, Form, Dimmer } from "tabler-react";
import postObject from '../../lib/postObject';

const PriceDetails = ({ shipment }) => {
  const [priceDetails, setPriceDetails] = useState(null)

  useEffect(() => {
    const tmp = {
      fromCity: shipment.fromCity,
      toCity: shipment.toCity,
      isHomeDelivery: shipment.isHomeDelivery,
      products: shipment.products
    }

    postObject('prices/calculate', tmp, true).then(data => {
      setPriceDetails(data.data)
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Form.FieldSet>
      <Dimmer active={!priceDetails} loader={!priceDetails}>
      <Grid>
        <Grid.Row>
          <Grid.Col>
            <Form.Label>Shipment Price</Form.Label>
            <div className="normalText">{priceDetails?.shipmentPrice}</div>

            <Form.Label>Reward</Form.Label>
            <div className="normalText">{priceDetails?.reward}</div>

            <Form.Label>Total</Form.Label>
            <div className="normalText">{`${priceDetails?.total?.from} -> ${priceDetails?.total?.to}`}</div>
          </Grid.Col>

          <Grid.Col>
            <Form.Label>MoveIT Fees</Form.Label>
            <div className="normalText">{priceDetails?.moveitFees}</div>

            <Form.Label>Delivery Fees</Form.Label>
            <div className="normalText">{priceDetails?.deliveryFees}</div>
          </Grid.Col>
        </Grid.Row>
      </Grid>
      </Dimmer>
    </Form.FieldSet>
  );
}
export default PriceDetails;